<template>
  <div>
    <div
      v-for="(goal, index) in goals" :key="goal.title + index"
      class="goal-container position-relative hover-container my-4"
    >
      <h3
        class="goal-title mb-3"
        :contenteditable="disabled ? 'false' : 'plaintext-only'"
        @keydown="userUpdateGoalTitle($event, index)"
        @blur="updateGoalTitle($event, index)"
      >{{goal.title}}</h3>
      <v-btn v-if="!disabled"
             variant="plain"
             icon="mds:delete"
             size="small"
             class="show-on-hover absolute-top-right ma-3"
             style="max-height: 18px !important; max-width: 18px;"
             @click="userDeleteGoal(index)"
      />
      <div class="pt-0">
        <text-editor
          class="editor"
          :index="index"
          :text="goal.description"
          :disabled="disabled"
          @text-update="userUpdateGoal"
          @move-focus="moveFocus">
        </text-editor>
      </div>
    </div>
    <div v-if="!goals?.length" class="my-8">
      {{ placeholder }}
    </div>
  </div>
</template>

<script>
import TextEditor from '@/components/TextEditor.vue'

export default {
  name: 'GoalList',
  props: {
    goals: Array,
    placeholder: String,
    disabled: Boolean
  },
  components: {
    TextEditor
  },
  methods: {
    userAddGoal () {
      const length = this.goals?.length || 0
      const goal = {
        title: 'Goal ' + (length + 1),
        description: '<p>New goal</p>'
      }
      let updatedGoals
      if (this.goals) {
        updatedGoals = [...this.goals, goal]
      } else {
        updatedGoals = [goal]
      }

      this.updateGoals(updatedGoals, 'added goal', goal.description, true)
    },

    userUpdateGoal (newDescription, _, index) {
      if (index < this.goals?.length) {
        const updatedGoals = JSON.parse(JSON.stringify(this.goals))
        updatedGoals[index].description = newDescription
        this.updateGoals(updatedGoals, 'updated goal', newDescription)
      }
    },

    userDeleteGoal (index) {
      if (index < this.goals?.length) {
        const description = this.goals[index].description
        const updatedGoals = [...this.goals]
        updatedGoals.splice(index, 1)
        this.updateGoals(updatedGoals, 'removed goal', description)
      }
    },

    userUpdateGoalTitle (event, index) {
      if (event.keyCode === 13) {
        this.updateGoalTitle(event, index)
        event.target.blur()
        event.preventDefault()
        event.stopPropagation()
      }
    },

    updateGoalTitle (event, index) {
      if (index < this.goals?.length) {
        const oldTitle = this.goals[index].title
        const newTitle = event.target.innerText.trim()
        if (newTitle === '') {
          event.target.innerText = oldTitle
          return
        }

        if (oldTitle !== newTitle) {
          const updatedGoals = JSON.parse(JSON.stringify(this.goals))
          updatedGoals[index].title = newTitle
          this.updateGoals(updatedGoals, 'updated goal title', newTitle)
        }
        event.target.innerText = newTitle
      }
    },

    updateGoals (updatedGoals, updateAction, description, isNewGoal) {
      const goals = updatedGoals.map(it => {
        return {
          description: it.description,
          title: it.title || null
        }
      })
      const updateNote = {
        action: updateAction,
        target: description
      }

      this.$emit('changed', goals, updateNote, isNewGoal)
    },

    moveFocus (direction, target) {
      target.firstChild.blur()
    }
  }
}
</script>

<style scoped>
.ql-container.ql-snow {
  border: none !important;
}

.goal-container {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #CFD3D9;
  background: #FFF;
}

.goal-title {
  color: #1D1F22;
  font-style: normal;
  font-weight: 500;
  line-height: 18.2px;
  outline: none transparent;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

.absolute-top-right {
  position: absolute;
  top: 0;
  right: 0;
}

.editor {
  padding: 3px 0 !important;
}

.delete-goal-btn .v-icon{
  visibility: hidden;
}

.delete-goal-btn:hover .v-icon {
  visibility: visible;
}

.show {
  opacity: 1;
}
</style>
